import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`
        inline-block 
        bg-[#e74c3c] 
        text-white 
        px-8 py-5 
        text-xl md:text-2xl 
        font-bold 
        no-underline 
        rounded-full 
        shadow-[0_6px_20px_rgba(231,76,60,0.4)] 
        transition-all 
        duration-300 
        hover:bg-[#c0392b] 
        hover:-translate-y-1 
        hover:shadow-[0_10px_30px_rgba(231,76,60,0.5)]
        text-center
        ${className}
      `} data-id="element-7">
      {children}
    </a>;
}